import * as React from "react";
import OpQuotesHeadingDsk, { IOpQuotesHeadingDskProps } from "../partials/opQuotesHeadingDsk";
import OpMarketDepthTable from "../partials/opMarketDepthTable";
import OpQuotesHoldings from "../partials/opQuotesHoldings";
import "../../../../../assets/scss/components/toc/orderPlacement/opQuotes/opQuotesDsk.scss";
import { IOpMarketDepthTableProps } from "./../partials/opMarketDepthTable";
import { useRouteMatch } from "react-router-dom";
import { toINR } from "../../../../service/numberFormat";

export interface IOpQuotesEquityDskProps {
	quoteData: any;
	holdingData?: any;
}

const OpQuotesEquityDsk: React.FC<IOpQuotesEquityDskProps> = props => {
	const futOpt = useRouteMatch().url.split("/")[3];

	const quotesHeadingProps: IOpQuotesHeadingDskProps = {
		dpNm: props.quoteData.qt?.dpNm,
		ltp: props.quoteData.qt?.ltp,
		chLTP: props.quoteData.qt?.chg,
		chLTPPer: props.quoteData.qt?.chgP,
		exc: props.quoteData.qt?.exc,
		ltt: props.quoteData.qt?.ltt,
		expiry:
			futOpt === "future"
				? `${props.quoteData.qt?.dpExpDt} ${props.quoteData.qt?.dpInsTyp || ""}`
				: futOpt === "option"
				? `${props.quoteData.qt?.dpExpDt} ${props.quoteData.qt?.opTyp} ${props.quoteData.qt?.stkPrc}`
				: undefined
	};

	const quotesDetilsProps: IOpMarketDepthTableProps = {
		open: props.quoteData.qt?.o,
		volume: props.quoteData.qt?.vol,
		high: props.quoteData.qt?.h,
		low: props.quoteData.qt?.l,
		tBidQty: props.quoteData.mkd?.buyQty,
		tAskQty: props.quoteData.mkd?.sellQty,
		ask: props.quoteData.mkd?.ask,
		bid: props.quoteData.mkd?.bid,
		spot: futOpt === "future" || futOpt === "option" ? props.quoteData.qt?.spot : undefined,
		opInt: futOpt === "future" || futOpt === "option" ? props.quoteData.qt?.opInt : undefined,
		opIntChgP: futOpt === "future" || futOpt === "option" ? props.quoteData.qt?.opIntChgP : undefined,
		hiCt: futOpt === "future" || futOpt === "option" ? props.quoteData.qt?.hiCt : undefined,
		loCt: futOpt === "future" || futOpt === "option" ? props.quoteData.qt?.loCt : undefined,
		ltSz: futOpt === "future" || futOpt === "option" ? props.quoteData.qt?.ltSz : undefined,
		bidivfut: futOpt === "option" ? props.quoteData.qt?.bidivfut : undefined,
		mns: futOpt === "option" ? props.quoteData.qt?.mns : undefined
	};

	return (
		<section className="quotes_cont">
			<OpQuotesHeadingDsk {...quotesHeadingProps} />

			<button className="change_btn" onClick={console.log}>
				Change
			</button>

			{props.holdingData && (
				<OpQuotesHoldings
					data={[
						{ label: "Total Quantity", value: toINR(+props.holdingData.hdQtyCnc + +props.holdingData.hdQtyMtf) },
						{
							label: "Total Value",
							value: `₹ ${toINR((+props.holdingData.hdQtyCnc + +props.holdingData.hdQtyMtf) * props.quoteData.mkd?.ask[0].price)}`
						}
					]}
					hldgOrPos="holding"
				/>
			)}

			{props.quoteData && <OpMarketDepthTable {...quotesDetilsProps} />}
		</section>
	);
};

export default OpQuotesEquityDsk;
